<ion-content [fullscreen]="true" [scrollY]="true" class="tyviso-offers-content">
  <div class="tyviso-offers-page main-container">
    <ion-row class="top-header">
      <ion-col class="heading-wrap ion-no-padding" size="11">
        <h1 class="page-heading">Claim a gift on us now</h1>
        <p class="page-subtitle">Claim one that suits you</p>
      </ion-col>
      <ion-col class="notification-wrap ion-no-padding" size="1" (click)="backToHomePage()">
        <img class="support-img" src="assets/images/close-circle.png" alt="close" />
      </ion-col>
    </ion-row>

    @if (loading) {
      <p class="tyviso-empty">Loading offers…</p>
    } @else if (errorMessage) {
      <p class="tyviso-empty">{{ errorMessage }}</p>
    }

    @if (!loading && heroOffers?.length) {
      <section class="tyviso-section tyviso-section--featured">
        @for (offer of heroOffers; track offer?.id || offer?.url || $index) {
          <div class="tyviso-offer">
            @if (offer?.image) {
              <img class="tyviso-offer-image" [src]="offer.image" [alt]="offer?.title || 'Offer'" />
            }
            @if (offer?.partner || offer?.partnerLogo) {
              <div class="tyviso-partner">
                @if (offer?.partnerLogo) {
                  <img class="tyviso-partner-logo" [src]="offer.partnerLogo" [alt]="offer?.partner || 'Partner'" />
                }
                @if (offer?.partner) {
                  <span>{{ offer.partner }}</span>
                }
              </div>
            }
            @if (offer?.title) {
              <h3>{{ offer.title }}</h3>
            }
            @if (offer?.description) {
              <p>{{ offer.description }}</p>
            }
            @if (hasTerms(offer)) {
              <div class="tyviso-terms-block">
                <button
                  type="button"
                  class="tyviso-terms-toggle"
                  [attr.aria-expanded]="isTermsExpanded('hero', offer, $index)"
                  [attr.aria-controls]="termsPanelId('hero', offer, $index)"
                  (click)="toggleTerms('hero', offer, $index, $event)"
                >
                  Terms
                  <svg
                    class="tyviso-terms-chevron"
                    [class.tyviso-terms-chevron--open]="isTermsExpanded('hero', offer, $index)"
                    viewBox="0 0 12 12"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path
                      d="M2.25 4.5L6 8.25L9.75 4.5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </button>
                @if (isTermsExpanded('hero', offer, $index)) {
                  <div
                    class="tyviso-terms-panel"
                    [id]="termsPanelId('hero', offer, $index)"
                    role="region"
                    aria-label="Offer terms"
                  >
                    <p class="tyviso-terms-text">{{ offer.terms }}</p>
                  </div>
                }
              </div>
            }
            <div class="tyviso-action-row foot-wrapper-promo">
              <ion-button class="capsule-promot-btn tyviso-claim-btn" (click)="openOffer(offer?.url)">
                {{ offer?.cta || 'Claim now' }}
              </ion-button>
            </div>
          </div>
        }
      </section>
    }

    @if (!loading && popularOffers?.length) {
      <section class="tyviso-section tyviso-section--featured">
        @for (offer of popularOffers; track offer?.id || offer?.url || $index) {
          <div class="tyviso-offer">
            @if (offer?.image) {
              <img class="tyviso-offer-image" [src]="offer.image" [alt]="offer?.title || 'Offer'" />
            }
            @if (offer?.partner || offer?.partnerLogo) {
              <div class="tyviso-partner">
                @if (offer?.partnerLogo) {
                  <img class="tyviso-partner-logo" [src]="offer.partnerLogo" [alt]="offer?.partner || 'Partner'" />
                }
                @if (offer?.partner) {
                  <span>{{ offer.partner }}</span>
                }
              </div>
            }
            @if (offer?.title) {
              <h3>{{ offer.title }}</h3>
            }
            @if (offer?.description) {
              <p>{{ offer.description }}</p>
            }
            @if (hasTerms(offer)) {
              <div class="tyviso-terms-block">
                <button
                  type="button"
                  class="tyviso-terms-toggle"
                  [attr.aria-expanded]="isTermsExpanded('popular', offer, $index)"
                  [attr.aria-controls]="termsPanelId('popular', offer, $index)"
                  (click)="toggleTerms('popular', offer, $index, $event)"
                >
                  Terms
                  <svg
                    class="tyviso-terms-chevron"
                    [class.tyviso-terms-chevron--open]="isTermsExpanded('popular', offer, $index)"
                    viewBox="0 0 12 12"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path
                      d="M2.25 4.5L6 8.25L9.75 4.5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </button>
                @if (isTermsExpanded('popular', offer, $index)) {
                  <div
                    class="tyviso-terms-panel"
                    [id]="termsPanelId('popular', offer, $index)"
                    role="region"
                    aria-label="Offer terms"
                  >
                    <p class="tyviso-terms-text">{{ offer.terms }}</p>
                  </div>
                }
              </div>
            }
            <div class="tyviso-action-row foot-wrapper-promo">
              <ion-button class="capsule-promot-btn tyviso-claim-btn" (click)="openOffer(offer?.url)">
                {{ offer?.cta || 'Claim now' }}
              </ion-button>
            </div>
          </div>
        }
      </section>
    }

    @if (!loading && allOffers?.length) {
      <section class="tyviso-section">
        @for (offer of allOffers; track offer?.id || offer?.url || $index) {
          <div class="tyviso-offer">
            @if (offer?.image) {
              <img class="tyviso-offer-image" [src]="offer.image" [alt]="offer?.title || 'Offer'" />
            }
            @if (offer?.partner || offer?.partnerLogo) {
              <div class="tyviso-partner">
                @if (offer?.partnerLogo) {
                  <img class="tyviso-partner-logo" [src]="offer.partnerLogo" [alt]="offer?.partner || 'Partner'" />
                }
                @if (offer?.partner) {
                  <span>{{ offer.partner }}</span>
                }
              </div>
            }
            @if (offer?.title) {
              <h3>{{ offer.title }}</h3>
            }
            @if (offer?.description) {
              <p>{{ offer.description }}</p>
            }
            @if (hasTerms(offer)) {
              <div class="tyviso-terms-block">
                <button
                  type="button"
                  class="tyviso-terms-toggle"
                  [attr.aria-expanded]="isTermsExpanded('all', offer, $index)"
                  [attr.aria-controls]="termsPanelId('all', offer, $index)"
                  (click)="toggleTerms('all', offer, $index, $event)"
                >
                  Terms
                  <svg
                    class="tyviso-terms-chevron"
                    [class.tyviso-terms-chevron--open]="isTermsExpanded('all', offer, $index)"
                    viewBox="0 0 12 12"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path
                      d="M2.25 4.5L6 8.25L9.75 4.5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </button>
                @if (isTermsExpanded('all', offer, $index)) {
                  <div
                    class="tyviso-terms-panel"
                    [id]="termsPanelId('all', offer, $index)"
                    role="region"
                    aria-label="Offer terms"
                  >
                    <p class="tyviso-terms-text">{{ offer.terms }}</p>
                  </div>
                }
              </div>
            }
            <div class="tyviso-action-row foot-wrapper-promo">
              <ion-button class="capsule-promot-btn tyviso-claim-btn" (click)="openOffer(offer?.url)">
                {{ offer?.cta || 'Claim now' }}
              </ion-button>
            </div>
          </div>
        }
      </section>
    }
  </div>
</ion-content>
